import React from "react";

export default function NotesTab({ project }) {
  return (
    <div className="project__card project__cardFull">
      <h3 className="project__cardTitle">Notes</h3>
      {project.notes && project.notes.length ? (
        <ul className="project__list">
          {project.notes.map((n) => (
            <li key={n}>{n}</li>
          ))}
        </ul>
      ) : (
        <p className="project__empty">No notes added yet.</p>
      )}
    </div>
  );
}
